import { useTwoFactorPromptState } from 'shared/components/TwoFactorPromptContext'
import { useAuthContext } from 'shared/components/AuthContext'
import { needsTwoFactorEnrollment } from 'shared/utils'

export const useTwoFactorPrompt = () => {
  const { auth } = useAuthContext()
  const { showTwoFactorPrompt, hideTwoFactorPrompt } = useTwoFactorPromptState()

  const promptIfTwoFactorDisabled = () => {
    if (!auth) return
    const user = auth.getCurrentUser()
    if (!user || !needsTwoFactorEnrollment(user)) return

    showTwoFactorPrompt()
  }

  return { promptIfTwoFactorDisabled, hideTwoFactorPrompt }
}
